import React, { useContext } from 'react';

import Context from '../../../../utils/context';

import styles from './index.module.css';

export default function BylvayIsi({ showFooter = false }) {
  const isMobile = useContext(Context).viewport.getIsMobile();
  const headerText = isMobile ? 'IMPORTANT SAFETY INFORMATION & INDICATION' : 'IMPORTANT SAFETY INFORMATION';
  return (
    <div className={styles.isi_wrapper}>
      <div className={styles.isi_header_bar}>
        <div className={styles.isi_header_inner}>
          <div className={styles.uses_header_cell}>USES</div>
          <div className={styles.isi_header_cell}>{headerText}</div>
        </div>
      </div>
      <div className={styles.isi_body}>
        <div className={styles.isi_columns}>
          <div className={styles.uses_column}>
            <div className={styles.column_body}>
              <p className={styles.section_title}>What is BYLVAY (odevixibat)?</p>
              <p className={styles.body_text}>BYLVAY is a prescription medicine for the treatment of itching in:</p>
              <ul className={styles.bullet_list}>
                <li className={styles.bullet_item}>
                  Patients 12 months of age and older with Alagille syndrome (ALGS)
                </li>
                <li className={styles.bullet_item}>
                  Patients 3 months of age and older with progressive familial intrahepatic cholestasis (PFIC)
                </li>
              </ul>
              <p className={styles.body_text}>
                <b>Limitation of Use:</b>
              </p>
              <p className={styles.body_text}>
                BYLVAY is not recommended for some PFIC type 2 patients who have specific{' '}
                <span className={styles.italic_body}>ABCB11</span> gene changes. Talk with your healthcare provider if
                you have questions.
              </p>
            </div>
          </div>
          <div className={styles.isi_column}>
            <div className={styles.column_body}>
              <p className={styles.section_title}>What are the possible side effects of BYLVAY?</p>
              <p className={styles.body_text}>
                <b>BYLVAY can cause serious side effects, including:</b>
              </p>
              <ul className={styles.bullet_list}>
                <li className={styles.bullet_item}>
                  You should not use BYLVAY if you have had or have an advanced stage of liver disease. Talk with your
                  healthcare provider if you have any liver conditions.
                </li>
                <li className={styles.bullet_item}>
                  Abnormal liver tests have been observed with use of BYLVAY. Liver tests should be obtained before
                  starting and periodically during therapy to monitor for liver injury. Immediately report to your
                  healthcare provider any signs or symptoms of liver injury, such as, nausea, vomiting, skin or the
                  whites of eyes turn yellow, dark or brown urine, pain on the right side of the abdomen, or loss of
                  appetite.
                </li>
                <li className={styles.bullet_item}>
                  Notify your healthcare provider if you experience new onset or worsening of diarrhea.
                </li>
                <li className={styles.bullet_item}>
                  BYLVAY may decrease the absorption of certain vitamins, which include vitamins A, D, E, and K (FSV or
                  fat-soluble vitamins). Your blood levels of these vitamins should be measured before starting and
                  periodically during treatment to assess for FSV deficiency. You may bleed more easily, may bleed
                  longer, or experience a bone fracture. Call your healthcare provider if you have any signs or symptoms
                  of bleeding.
                </li>
              </ul>
              <p className={styles.body_text}>
                <b>The most common side effects of BYLVAY include:</b>
              </p>
              <ul className={styles.bullet_list}>
                <li className={styles.bullet_item}>
                  The most common side effects of BYLVAY treatment in patients with ALGS are diarrhea, abdominal pain,
                  abnormal bleeding, such as bruising, and decreased weight.
                </li>
                <li className={styles.bullet_item}>
                  The most common side effects of BYLVAY in patients with PFIC are diarrhea, liver test abnormalities,
                  vomiting, abdominal pain, and FSV deficiency.
                </li>
                <li className={styles.bullet_item}>
                  Do not swallow the 200 mcg or 600 mcg capsule(s) containing Oral Pellets whole. These are intended to
                  be opened and the contents mixed into soft food.
                </li>
                <li className={styles.bullet_item}>
                  For patients taking bile acid binding resins, take BYLVAY at least 4 hours before or 4 hours after
                  taking a bile acid binding resin.
                </li>
                <li className={styles.bullet_item}>
                  There is a pregnancy safety study that collects outcome data in women taking BYLVAY during pregnancy.
                  Pregnant women exposed to BYLVAY should report if they have used BYLVAY during pregnancy by calling
                  1-855-463-5127 and contact your doctor immediately.
                </li>
              </ul>
              <p className={styles.body_text}>
                <b>
                  You are encouraged to report side effects to FDA at <a href='tel:18003321088'>1-800-FDA-1088</a> or
                  at{' '}
                </b>
                <a href='https://www.fda.gov/medwatch' target='_blank' rel='noreferrer'>
                  www.fda.gov/medwatch
                </a>
                <b>. You may also report side effects to Ipsen Biopharmaceuticals, Inc. at 1-855-463-5127.</b>
              </p>
              <p className={styles.body_text}>
                <b>Please see full </b>
                <a
                  href='https://d2rkmuse97gwnh.cloudfront.net/a88aa6d6-3ca0-4362-a711-d53c45ae33ff/5f7d23c0-f85b-4f9a-907a-3f2fa18aa260/5f7d23c0-f85b-4f9a-907a-3f2fa18aa260_source__v.pdf'
                  target='_blank'
                  rel='noreferrer'
                >
                  Prescribing Information
                </a>{' '}
                <b>and </b>
                <a
                  href='https://d2rkmuse97gwnh.cloudfront.net/a88aa6d6-3ca0-4362-a711-d53c45ae33ff/654d0431-ec8d-45f0-ba80-8a33c9df68ab/654d0431-ec8d-45f0-ba80-8a33c9df68ab_source__v.pdf'
                  target='_blank'
                  rel='noreferrer'
                >
                  Instructions for Use
                </a>{' '}
                <b>for BYLVAY.</b>
              </p>
            </div>
          </div>
        </div>
        {showFooter && (
          <div className={styles.isi_footer}>
            <div className={styles.footer_logo}>
              <img
                src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/logos/png/Ipsen_logo.png'
                alt='Ipsen logo'
                className={styles.logo_img}
              />
            </div>
            <div className={styles.footer_copyright}>
              Bylvay is a registered trademark of Albireo Pharma, Inc., an Ipsen Company. © 2026 Ipsen
              Biopharmaceuticals, Inc. All rights reserved. All other trademarks are the property of their respective
              owners. March 2026. BYL-US-003096
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
